
























import Vue from 'vue'
export default Vue.extend({
  computed: {
    rootPath(): string {
      return process.env.VUE_APP_ROOT_PATH || ''
    },
    newRootPath(): string {
      return process.env.VUE_APP_NEW_ROOT_PATH || ''
    },
    isMemberLoggedIn(): boolean {
      return !!this.$store.state.memberId || !!this.$store.state.submitMemberId || !!this.$store.state.externalId
    },
    isVisiterLoggedIn(): boolean {
      return !!this.$store.state.user.uid
    },
    memberSignOutUrl(): string {
      return `${this.rootPath}/participant/sign-out`
    },
    visiterSignInUrl(): string {
      return `/tensaku_visiter/sign_in/${this.$store.state.examInfo.examGroupKey}`
    },
    logoUrl(): string {
      if (this.$route.path.startsWith('/new/')) {
        return `${this.newRootPath}/`
      }
      if (this.$route.path === '/tensaku_visiter/sign_in') {
        return `/tensaku_visiter/sign_in`
      }
      if (this.isVisiterLoggedIn) {
        return `/tensaku_visiter/`
      } else {
        return `${this.rootPath}/participant/my-page`
      }
    }
  },
  methods: {
    memberSignOut() {
      this.$store.dispatch('deleteAuth')
      // 新サイト（externalIdでログイン中）の場合は新サイト用ログアウト先へ遷移
      if (this.$store.state.externalId) {
        // TODO: ログアウトURL未定のため暫定
        window.location.href =  `${this.newRootPath}/users/auth/logout`
      } else {
        window.location.href = this.memberSignOutUrl
      }
    },
    visiterSignOut() {
      this.$store.dispatch('deleteAuth')
      this.$router.push(this.visiterSignInUrl)
    }
  }
})
